export enum GsnWeb3ProviderFailCode {
  NO_CONFIGURATION = 'gsn_no_configuration',
  RELAY_NOT_AVAILABLE = 'gsn_relay_not_available',
  WRONG_CHAIN_ID = 'gsn_wrong_chain_id',
  NO_SUPPORTED_TOKENS = 'there_are_no_supported_tokens',
}
